import React from 'react';
import './EmptyState.scss';

interface IEmptyStateProps {
	title: string;
}

export const EmptyState = (props: IEmptyStateProps): JSX.Element => {
	const { title } = props;
	return (
		<span
			className="indicator-progress position-absolute fs-4 d-block text-position"
		>
			{title}
		</span>
	);
};
